import { IDestination } from '../models';

export function fromJsonApi(data: any[]): IDestination[] {
  return data.map((item) => {
    const { id, attributes: { name, included } } = item;

    return {
      id,
      name,
      included,
    };
  });
}
